import { ReactNode } from 'react';

import { Text } from '@/design-system/components/Text';
import { cn } from '@/utils/tailwind';

export interface CreateDatasetFormSectionProps {
  name?: ReactNode;
  element: ReactNode;
  hide?: boolean;
  sectionDescription?: ReactNode;
  lg?: boolean;
}

const CreateDatasetFormSection = (props: CreateDatasetFormSectionProps) => {
  return (
    <div
      className={cn(
        'my-5 grid grid-cols-1 gap-4 ',
        props.hide && 'invisible',
        props.lg
          ? 'lg:grid-cols-[minmax(0,260px)_minmax(0,1fr)]'
          : 'lg:grid-cols-[minmax(0,260px)_minmax(0,1fr)_minmax(0,260px)]'
      )}
    >
      <div className="flex flex-col lg:pr-4">
        {props.name && (
          <Text variant="h3" className="text-left">
            {props.name}
          </Text>
        )}
        {props.sectionDescription && (
          <Text variant="sm" color="quaternary" className="mt-2">
            {props.sectionDescription}
          </Text>
        )}
      </div>
      <div className="w-full">{props.element}</div>
      <div className="hidden lg:block" />
    </div>
  );
};

export { CreateDatasetFormSection };
